// For compatibility with "id" options.
// Bad:  { id:  "en", label: "English" }
// Good: { key: "en", label: "English" }
export const getOptionKey = (option) =>
  option && (typeof option === "string" ? option : option.key || option.id);
